import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { changeFieldProperty, changeFormField, changeFormFieldValue, setFieldError, updateFields, updateFieldValues } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields, validationOnRequiredAndReturnErrorFields } from 'apps/auth/components/form-multi/utils';
import EqualNameAndNameFPopup from 'apps/auth/components/send/popups/errors/EqualNameAndNameFPopup';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import {
    ADRESS_SCREEN_SHOWN,
    EMAIL_SCREEN_SHOWN,
    LEAVE_EMAIL_SCREEN_SHOWN,
    LEAVE_EMAIL_SEND_CLICKED,
    PERSONAL_INFO_SCREEN_SHOWN,
    UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED,
    UNSUPPORTED_CHARACTERS_ERROR_SHOWN,
    UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { COUNTRY_OF_RESIDENCE, FLOW } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SIGNUP_AMPLITUDE } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { NAME, NAME_F, POST_CODE, RESIDENT_COUNTRY, TYPE } from 'apps/auth/constants/fieldsName';
import { TEXT } from 'apps/auth/constants/FieldType';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

import { DISCLAIMER_SCREEN } from './constants';
import { changeBirthdayDateFormat } from './utils';

function useAutoCompletePostCode(formName, post_code, resident_country, props) {
    useEffect(() => {
        if (props.fromWaitingList) {
            props.sendEvent(LEAVE_EMAIL_SCREEN_SHOWN);
        }
    }, []);

    useEffect(() => {
        if (formName === LOGIN_REGISTRATION_FORM_NAME) {
            const type = TEXT;
            props.changeFieldProperty(formName, POST_CODE, TYPE, type);
        }
    }, [resident_country]);
}

const FillProfile = ({ formName, ...props }) => {
    const [customValue, setCustomValue] = useState(props.countryName);
    const [toggleAmplitude, setToggleAmplitude] = useState(true);
    const [registrationDisclaimer] = useState(false);
    const [disabledAddressInput, setDisabledAddressInput] = useState(false);
    const { phoneCountry, simpleRegistration, showDisclaimer, fieldForSecondScreen } = useExtra();
    const { fields } = useForm(formName);
    const submitRef = useRef(null);
    const modalRef = useRef(null);
    const { button, headerTitle, headerGrayTitle, headerTitleEmail, headerGrayTitleEmail, learnMore } = usePageMessages();

    const nameFieldShown = fields?.name?.visible && !fields?.name?.value;
    const addressFieldShown = fields?.address?.visible && !fields?.address?.value;
    const emailFieldShown = fields?.email?.visible && !fields?.email?.value;
    const emptyCountryFieldShown = fields?.resident_country?.visible && !fields?.resident_country?.value;

    useEffect(() => {
        props.getFillProfileForms();
    }, []);

    useEffect(() => {
        if (fields?.resident_country?.visible && props.countryList) {
            const currentCountry = props.countryList.find(({ id }) => id === fields?.resident_country?.value);
            setCustomValue(currentCountry?.name);
        }
    }, [fields?.resident_country?.value, fields?.resident_country?.visible]);

    useEffect(() => {
        if (fields?.birthday?.value) {
            changeBirthdayDateFormat(fields.birthday, props.changeFieldProperty);
        }
    }, [fields?.birthday?.value]);

    useEffect(() => {
        if (nameFieldShown) {
            if (toggleAmplitude) {
                amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_SHOWN, { [COUNTRY_OF_RESIDENCE]: phoneCountry?.nameEn });
                setToggleAmplitude(false);
            }
        } else if (addressFieldShown) {
            amplitude.getInstance().logEvent(ADRESS_SCREEN_SHOWN, {
                [COUNTRY_OF_RESIDENCE]: phoneCountry?.nameEn,
                [FLOW]: SIGNUP_AMPLITUDE,
            });
        } else if (emailFieldShown && !props.fromWaitingList) {
            amplitude.getInstance().logEvent(EMAIL_SCREEN_SHOWN);
        }
    }, [nameFieldShown, addressFieldShown, emailFieldShown]);

    useEffect(() => {
        if (emptyCountryFieldShown) {
            setDisabledAddressInput(true);
        } else {
            setDisabledAddressInput(false);
        }
    }, [emptyCountryFieldShown]);

    const getSubTitle = () => {
        if (simpleRegistration) {
            return headerGrayTitleEmail;
        } else {
            return headerGrayTitle;
        }
    };

    const submitHandler = (fieldsFromRequest, json) => {
        props.submitHandler(fieldsFromRequest, json);
        if (json.messages) {
            props.updatePageMessages(json.messages);
        }
        if (json.extra.sameNameNameFPopup) {
            props.popupRef?.current?.open(<EqualNameAndNameFPopup popupRef={props.popupRef} />);
        } else if (json.extra.suggestionName) {
            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_ERROR_SHOWN);
            props.popupRef?.current?.open(
                <SimplePopup popupRef={props.popupRef} text={<DangerouslyHtml dangerouslyHtml={json.messages?.transliterationTextPopup} />}>
                    <PopupButton
                        iconName="arrow-back-circular"
                        text={json.messages?.goBackAndEditButton}
                        onClick={() => {
                            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED);
                            props.popupRef?.current?.close();
                        }}
                    />
                    <PopupButton
                        iconName="arrow-forward"
                        text={json.messages?.acceptAndContinueButton}
                        onClick={() => {
                            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED);
                            const fieldsNameSurname = {
                                name: json.extra.suggestionName,
                                name_f: json.extra.suggestionNameF,
                            };
                            props.updateFieldValues(formName, fieldsNameSurname).then(() => {
                                submitRef.current?.click();
                                props.popupRef?.current?.close();
                            });
                        }}
                    />
                </SimplePopup>,
            );
        } else if (json.extra?.backendDidNotResponseForTransliteration) {
            let name = fields[NAME];
            name.placeholder = json.messages?.placeHolderForName;
            name.checkRegexp = json.extra?.latinRegexForName;
            let name_f = fields[NAME_F];
            name_f.checkRegexp = json.extra?.latinRegexForName;
            name_f.placeholder = json.messages?.placeHolderForNameF;
            props
                .updateFields(formName, { name, name_f })
                .then(
                    Object.keys(json.extra.errorForNameSurname).forEach((nameError) =>
                        props.setFieldError(formName, nameError, json.extra.errorForNameSurname[nameError]),
                    ),
                );
        }
    };

    const beforeSubmit = () => clearLeadingSpace(fields, formName, props.changeFormFieldValue);

    const clearFieldsOnCountrySelect = () => {
        fieldForSecondScreen.forEach((name) => {
            if (name !== RESIDENT_COUNTRY && fields[name]?.value) {
                props.changeFormFieldValue(formName, null, name);
            }
        });
    };

    useAutoCompletePostCode(formName, fields.post_code, fields.resident_country, props);
    return (
        <>
            <HeaderPanel title={simpleRegistration ? headerTitleEmail : headerTitle} subtitle={getSubTitle()} />
            <Form
                formName={formName}
                onSubmitHandler={props.fromWaitingList ? props.onSubmitHandler : submitHandler}
                getCanonicalPath={props.getCanonicalPath}
                action={props.action}
                checkNotVisibleField={false}
                beforeSubmit={beforeSubmit}
            >
                <fieldset>
                    {getSortFields(fields).map((f) => {
                        const field = fields[f.name];
                        if (field?.visible) {
                            return (
                                <Row key={`${formName}-fields-${field.name}`}>
                                    <InputAutoDetect
                                        customValue={customValue}
                                        field={field}
                                        formName={formName}
                                        country={phoneCountry}
                                        isClearErrorOnFocus={true}
                                        disabledAddressInput={!!disabledAddressInput}
                                        clearFieldsOnCountrySelect={clearFieldsOnCountrySelect}
                                        checkBoxButtonCaption={learnMore}
                                        modalRef={modalRef}
                                        alwaysHasHint
                                    />
                                </Row>
                            );
                        }
                    })}
                </fieldset>
                <FixedBottomPanel isRightAligned buttonPosition={simpleRegistration ? props.buttonPosition : null}>
                    <Button
                        type="submit"
                        raised={true}
                        caption={button}
                        ref={submitRef}
                        onClick={(e) => {
                            if (simpleRegistration && showDisclaimer) {
                                if (
                                    !registrationDisclaimer &&
                                    validationOnRequiredAndReturnErrorFields(formName, fields, props.changeFormField, false).length > 0
                                ) {
                                    e.preventDefault();
                                } else {
                                    props.setScreen(DISCLAIMER_SCREEN);
                                }
                            }
                            if (props.fromWaitingList) {
                                props.sendEvent(LEAVE_EMAIL_SEND_CLICKED);
                            }
                        }}
                    />
                </FixedBottomPanel>
            </Form>
            <ModalNew ref={modalRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        countryName: state.extra?.phoneCountry?.name,
        countryList: state.extra?.country_list,
        country: state.app?.country,
        lang: state.language?.lang,
        action: state.form?.loginRegistration?.action,
    };
};

export default connect(mapStateToProps, {
    changeFormField,
    changeFieldProperty,
    changeFormFieldValue,
    validationOnRequiredAndReturnErrorFields,
    setFieldError,
    updatePageMessages,
    updateFields,
    updateFieldValues,
})(FillProfile);
